interface DocSectionProps {
  readonly title: string
  readonly description?: string
  readonly children: React.ReactNode
}

export function DocSection({ title, description, children }: DocSectionProps) {
  return (
    <section className="space-y-3">
      <div>
        <h2 className="text-lg font-semibold tracking-tight">{title}</h2>
        {description && (
          <p className="text-sm text-muted-foreground mt-1">{description}</p>
        )}
      </div>
      <div className="space-y-4">{children}</div>
    </section>
  )
}
